import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString } from "vue"

import numeral from 'numeral';

  export interface IProps {
    value: number | string;
    format: string;
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    value: { default: 0 },
    format: { default: '0,0' }
  },
  setup(__props: any) {

  ;

  


return (_ctx: any,_cache: any) => {
  return _toDisplayString(_unref(numeral)(__props.value).format(__props.format))
}
}

})